import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, intlShape, FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { SbSharedRefineMenuSearchInput } from '../SbSharedRefineMenu/SbSharedRefineMenuSearchInput/SbSharedRefineMenuSearchInput';
import { SbSharedSearchCategoryTile } from '../SbSharedSearchCategoryTile/SbSharedSearchCategoryTile';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { QP_SEARCH_QUERY } from '../../constants/queryParamConstants';

import copy from './CategoryTilesCopy.json';

import styles from './SbSharedSearchLandingLayout.scss';

const messages = defineMessages({
    searchBar: {
        id: 'SbSharedSearchLandingLayout.searchBar',
        defaultMessage: 'Search for items, creators, or styles',
    },
});

function SbSharedSearchLandingLayoutComponent({ intl, isVisible }) {
    const { isMobile } = useContext(ServerVarsContext);

    const [term, onTermChange] = useState('');
    const searchBarCopy = intl.formatMessage(messages.searchBar);
    const onSubmit = e => {
        e.preventDefault();

        if (term) {
            location.assign(
                `${location.origin}/search/?${QP_SEARCH_QUERY}=${encodeURIComponent(
                    term.toLowerCase()
                )}`
            );
        }
    };

    return (
        <div className={classnames(styles.wrapper, { 'is-invisible': !isVisible })}>
            <BarHeader
                title={
                    <FormattedMessage
                        id="SbSharedSearchLandingLayout.title"
                        defaultMessage="Search"
                    />
                }
            />

            {!isMobile && (
                <div className={`rowFlex ${styles.searchBarWrapper}`}>
                    <SbSharedRefineMenuSearchInput
                        className="colMd4 colXs12"
                        onInput={e => onTermChange(e.target.value)}
                        value={term}
                        placeholder={searchBarCopy}
                        onSubmit={onSubmit}
                        size="large"
                    />
                </div>
            )}

            <div className="rowFlex">
                {copy.items.map((item, index) => (
                    <div key={index} className={`${styles.categoryTile} colMd3 colXs12`}>
                        <SbSharedSearchCategoryTile
                            imageUrl={item.imageUrl}
                            category={item.category}
                            url={item.url}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

SbSharedSearchLandingLayoutComponent.propTypes = {
    intl: intlShape,
    isVisible: PropTypes.bool,
    updateUriRef: PropTypes.func.isRequired,
};

SbSharedSearchLandingLayoutComponent.defaultProps = {
    isVisible: true,
};

export const SbSharedSearchLandingLayout = injectIntl(SbSharedSearchLandingLayoutComponent);
